/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Buyer_CancelInputs */

const vi_einvoice_buyer_cancel = /** @type {(inputs: Einvoice_Buyer_CancelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy sửa`)
};

/**

* @param {Einvoice_Buyer_CancelInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_buyer_cancel = /** @type {((inputs?: Einvoice_Buyer_CancelInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Buyer_CancelInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_buyer_cancel(inputs)
});